import { Pipe, PipeTransform } from '@angular/core';
import { WIFI_STATUS_MAPPING } from '@lib/wifi-hotspot.consts';

@Pipe({ name: 'wifiStatus' })
export class WifiStatusPipe implements PipeTransform {
  public transform(wifiStatus: string): string {
    return WIFI_STATUS_MAPPING[wifiStatus];
  }
}